import { useTranslation } from 'react-i18next';

export default function EnvUnsupported(): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50 p-4">
      <section className="bg-white max-w-sm w-full p-6 rounded-lg shadow-lg text-center">
        <h1 className="text-2xl font-semibold mb-4">{t('envUnsupported.title')}</h1>
        <p className="text-gray-200 leading-relaxed">{t('envUnsupported.description')}</p>
      </section>
    </div>
  );
}
